import { NavItem } from './styled';
import { useTracking } from 'react-tracking';
import { routes } from '@/constants/primaryNavigation';
import { ROUTE_HOME } from '@/constants/routes';
import { useHomeRoute } from '@/hooks/useHomeRoute';

interface Props {
  location: string;
}

export function Nav({ location }: Props) {
  const { trackEvent } = useTracking();
  const homeRoute = useHomeRoute();
  return (
    <>
      {routes.map(({ to, label, matches }) => {
        const selected = matches.includes(location);
        return (
          <NavItem
            key={`desktop-header-menu-item-${to}`}
            to={{
              type: to === ROUTE_HOME ? homeRoute : to,
            }}
            inheritColor
            noUnderline
            selected={selected}
            onClick={() => {
              !matches.includes(location) &&
                trackEvent({
                  modifier: label,
                  action: 'click',
                });
            }}
          >
            {label}
          </NavItem>
        );
      })}
    </>
  );
}
